import React from 'react';
import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../Types/ParamsPicklist';
import { Box, TextField, Typography } from '@mui/material';
import { Input } from 'antd';


let searchTypAdr: Params = { CodeAgence: '', Table: "TYPADR", Colonne1: "CODTYPE", Colonne2: "LIBELL1", Colagence: '001', Choix: 22 }

const Tab2: React.FC = (props: { form?: any }) => (

  <div className='tabItem'>
    <div >
      <Box fontStyle="inherit" width={"85%"} position={"absolute"}>
        <Box fontStyle="inherit" className='border-left border'>
          <legend>Plafond Client</legend>
          <Box fontStyle="inherit" display={"flex"}>
            <Box className='border-left' >
              <InputForm defaultValue={0} width={17} title="Débit max compte interne" label='Débit max compte interne' name='debint' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Débit max compte client" label='Débit max compte client' name='debClt' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Validation max compte interne" label='Validation max compte interne' name='validInt' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Dépassement max compte interne" label='Dépassement max compte interne' name='depassInt' type='text' error='mobile' />
            </Box>
            <Box className='border-left' >
              <InputForm defaultValue={0} width={17} title="Seuil d'alerte débit compte client" label="Seuil d'alerte débit compte client" name='alertDebClt' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Dépassement max compte user" label='Dépassement max compte user' name='depassCpt' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Crédit max compte interne" label='Crédit max compte interne' name='credInt' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Crédit max compte client" label='Crédit max compte client' name='credClt' type='text' error='mobile' />
            </Box>
            <Box className='border-left' >
              <InputForm defaultValue={0} width={17} title="Validation max compte client" label='Validation max compte client' name='validClt' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Dépassement compte client" label='Dépassement compte client' name='depassClt' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Seuil d'alerte crédit compte client" label="Seuil d'alerte crédit compte client" name='alertCreClt' type='text' error='mobile' />
            </Box>
          </Box>
        </Box>
        <Box fontStyle="inherit" className='border-left border'>
          <legend>Plafond à distnce</legend>
          <Box fontStyle="inherit" display={"flex"} minWidth={"100%"}>
            <Box className='border-left' >
              <InputForm defaultValue={0} width={17} title="Débit max compte interne" label='Débit max compte interne' name='debInt2' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Débit max compte client" label='Débit max compte client' name='debClt2' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Validation max compte interne" label='Validation max compte interne' name='validInt2' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Dépassement max compte interne" label='Dépassement max compte interne' name='depassInt2' type='text' error='mobile' />
            </Box>
            <Box className='border-left' >
              <InputForm defaultValue={0} width={17} title="Seuil d'alerte débit compte client" label="Seuil d'alerte débit compte client" name='alertDebClt2' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Dépassement max compte user" label='Dépassement max compte user' name='depassCpt2' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Crédit max compte interne" label='Crédit max compte interne' name='credInt2' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Crédit max compte client" label='Crédit max compte client' name='credClt2' type='text' error='mobile' />
            </Box>
            <Box className='border-left' >
              <InputForm defaultValue={0} width={17} title="Validation max compte client" label='Validation max compte client' name='validClt2' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Dépassement compte client" label='Dépassement compte client' name='depassClt2' type='text' error='mobile' />
              <InputForm defaultValue={0} width={17} title="Seuil d'alerte crédit compte client" label="Seuil d'alerte crédit compte client" name='alertCreClt2' type='text' error='mobile' />
            </Box>
          </Box>
        </Box>

      </Box>
    </div>
  </div>
);

export default Tab2;